const header = document.querySelector('.header');
const headerTop = document.querySelector('.c-top');
const headerBottom = document.querySelector('.c-bottom');
const body = document.querySelector('body');
let scrollPos = 0;
const scrollPosHidden = 200;

/**
 * Calculate if the users scroll position is at end of the page
 */
function calculateScrollPosition() {
  const docRef = document.documentElement;
  const offset = docRef.scrollTop + window.innerHeight;
  const height = docRef.offsetHeight;

  if (Math.round(offset) >= height) {
    return true;
  } else {
    return false;
  }
}

/**
 * Sets the different states of the sticky menu
 */
function handleStickyHeader() {
  const windowY = window.scrollY;

  if (headerTop) {
    // Check if menu should be sticky
    if (windowY > headerTop.offsetHeight) {
      body.classList.add('is-sticky');
      header.classList.add('sticky');
      headerBottom.classList.add('sticky');
    } else {
      body.classList.remove('is-sticky');
      header.classList.remove('sticky');
      headerBottom.classList.remove('sticky');
    }

    // Check if menu must be hidden
    if (windowY >= scrollPosHidden && !calculateScrollPosition()) {
      body.classList.add('hidden');
      header.classList.add('hidden');
    } else {
      body.classList.remove('hidden');
      header.classList.remove('hidden');
    }

    // If user scroll up > show menu
    if (windowY < scrollPos) {
      body.classList.remove('hidden');
      header.classList.remove('hidden');
    }

    scrollPos = windowY;
  }
}

export { handleStickyHeader };
